<iframe [src]="urlSafe" class="doc-iframe"></iframe>
